import { Link } from "react-scroll";
import photo from "../../assets/images/agence/agence.webp";
import profile from "../../assets/images/agence/CVPHOTO.webp";
import AnimatedScroll from "../../components/AnimatedScroll/AnimatedScroll";
import AnimatedLi from "../../components/AnimatedScroll/AnimatedLi";

function About() {
  return (
    <section id="about" className="about">
      <div className="section-heading text-center">
        <AnimatedScroll>
          <h2 id="aboutTitle">
            L'agence Dev'Alls - Experts en Développement Web 🏢
          </h2>
        </AnimatedScroll>
      </div>
      <div className="container">
        <div className="about-content">
          <div className="photoText">
            <div className="col-sm-offset-1 col-sm-5 photoAbout">
              <AnimatedScroll>
                <div className="single-about-image">
                  <img src={photo} alt="profile_image" />
                </div>
              </AnimatedScroll>
            </div>
            <div className="row">
              <div id="textAbout" className="col-sm-6 textAbout">
                <div className="single-about-txt agency">
                  <AnimatedScroll>
                    <h3 className="h3_about">
                      🏆 Créée en 2025, une agence jeune et innovante
                    </h3>
                  </AnimatedScroll>
                  <AnimatedScroll>
                    <p className="h3A">
                      Fondée en 2025, notre agence s’est donné pour mission
                      d’accompagner les entreprises, startups et entrepreneurs
                      dans la conception de solutions digitales performantes et
                      modernes. Grâce à une équipe passionnée et expérimentée,
                      nous mettons en place des stratégies web efficaces et
                      adaptées aux besoins de chaque client.
                    </p>
                  </AnimatedScroll>
                </div>
              </div>
            </div>
          </div>
          <div className="liste_agence">
            <div>
              <AnimatedScroll>
                <h4>💡 Nos valeurs</h4>
              </AnimatedScroll>
              <ul>
                <AnimatedLi>
                  ✅ Innovation : Toujours à la pointe des technologies pour des
                  solutions évolutives.
                </AnimatedLi>

                <AnimatedLi>
                  ✅ Qualité : Chaque projet est réalisé avec une exigence
                  élevée en performance et design.
                </AnimatedLi>

                <AnimatedLi>
                  ✅ Proximité : Une communication transparente et un suivi
                  personnalisé.
                </AnimatedLi>
                <AnimatedLi>
                  ✅ Engagement : Votre réussite est notre priorité, et nous
                  travaillons à atteindre vos objectifs.
                </AnimatedLi>
              </ul>
            </div>
            <div>
              <AnimatedScroll>
                <h4>📌 Nos domaines d’expertise</h4>
              </AnimatedScroll>
              <ul>
                <AnimatedLi>
                  🔹 Développement web (sites vitrines, e-commerce, SaaS,
                  applications web)
                </AnimatedLi>
                <AnimatedLi>
                  🔹 UI/UX Design et branding (création d'identité visuelle,
                  maquettes ergonomiques)
                </AnimatedLi>
                <AnimatedLi>
                  🔹 Optimisation SEO et marketing digital (référencement
                  naturel, stratégie de contenu)
                </AnimatedLi>
                <AnimatedLi>
                  🔹 Hébergement, maintenance et sécurité (serveurs performants,
                  mises à jour, protection des données)
                </AnimatedLi>
              </ul>
            </div>
            <div>
              <AnimatedScroll>
                <h4>🎯 Pourquoi choisir notre agence ?</h4>
              </AnimatedScroll>
              <ul>
                <AnimatedLi>
                  ✔️ Une équipe dynamique et réactive, toujours à l’écoute
                </AnimatedLi>
                <AnimatedLi>
                  ✔️ Des solutions sur-mesure, adaptées aux besoins spécifiques
                  de chaque client
                </AnimatedLi>
                <AnimatedLi>
                  ✔️ Une expertise technique avancée pour garantir des résultats
                  performants
                </AnimatedLi>
                <AnimatedLi>
                  ✔️ Un accompagnement à long terme, avec un suivi et des
                  optimisations continues
                </AnimatedLi>
              </ul>
            </div>
          </div>
          <section id="team" className="team">
            <div className="h4_title">
              <AnimatedScroll>
                <h4>🏅 Notre équipe</h4>
              </AnimatedScroll>
            </div>

            <div
              className="container aos-init aos-animate"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="row gy-5 team-entier">
                <div
                  className="col-xl-4 col-md-6 card-member"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <div className="team-member">
                    <div className="member-img">
                      <AnimatedScroll>
                        <img
                          src={profile}
                          className="img-fluid"
                          alt="sannier yoan"
                        />
                      </AnimatedScroll>
                    </div>
                    <AnimatedScroll>
                      <div className="member-info">
                        <div className="social">
                          <a
                            href="https://github.com/SanYoan"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="GitHub"
                          >
                            <i className="fa fa-github"></i>
                          </a>
                          <a
                            href="https://www.linkedin.com/in/yoan-sannier-4367211b9/"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="linkedIn"
                          >
                            <i className="fa fa-linkedin"></i>
                          </a>
                        </div>
                        <h4>Yoan Sannier</h4>
                        <span>Dirigeant - Développeur Full-Stack React.JS</span>
                      </div>
                    </AnimatedScroll>
                  </div>
                </div>
              </div>
              <div className="text-center mt-8">
                <AnimatedScroll>
                  <Link
                    className="btn_team"
                    to="contact"
                    href="#contact"
                    smooth={true}
                    duration={1000}
                  >
                    Travaillons ensemble !{" "}
                  </Link>
                </AnimatedScroll>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
}

export default About;
